module.exports = __webpack_public_path__ + "assets/weather-list.63407db7.svg";